import React from "react";
import { useAuth } from "../context/AuthContext";

const Login = () => {
  const { login } = useAuth();
  console.log('Login page Logging in')
  login()
  return (
    <div>
    </div>
  );
};

export default Login;
